import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import {BoInstanceSelectorRequest} from '../model/BoInstanceSelectorRequest';
import {HttpEvent} from '@angular/common/http';
import {BoInstanceSelectorFilter} from '../model/BoInstanceSelectorFilter';
import {BoInstanceSelectorRecord} from '../model/BoInstanceSelectorRecord';
import {BusinessObjectDetails} from '../model/BusinessObjectDetails';
import {BoInstanceToSave} from '../model/BoInstanceToSave';
import {BoAutocompleteOptionsRequest} from '../model/BoAutocompleteOptionsRequest';
import {BoAutocompleteOption} from '../model/BoAutocompleteOption';
import {BoInstance} from '../model/BoInstance';
import {TableInstanceRecord} from '../model/TableInstanceRecord';
import {BoInstanceAmountToSave} from '../model/BoInstanceAmountToSave';
import {BoiDialogData} from '../model/BoiDialogData';
import {BoInstanceDialogType} from '../model/BoInstanceDialogType';

export const DYNAMIC_FORMS_SERVICE = new InjectionToken<DynamicFormsService>('DynamicFormsService');

export interface DynamicFormsService {
  uploadFile(file: File): Observable<HttpEvent<string>>;

  loadMaxFileSize(): Promise<number>;

  downloadFile(fileId: string): void;

  loadBoInstanceRecordsByIds(request: BoInstanceSelectorRequest): Observable<BoInstanceSelectorRecord[]>;

  loadBoInstanceRecords(search: BoInstanceSelectorFilter): Observable<BoInstanceSelectorRecord[]>;

  loadBoDetails(businessObjectId: string, boInstanceDialogType: BoInstanceDialogType, boiId: string): Promise<BusinessObjectDetails>;

  loadBoInstance(businessObjectId: string, boInstanceId: string): Observable<BoInstance>;

  loadBoAutocompleteOptions(req: BoAutocompleteOptionsRequest): Promise<BoAutocompleteOption[]>;

  saveBoInstance(boToSave: BoInstanceToSave): Observable<TableInstanceRecord>;

  saveBoInstanceAmount(boInstanceAmountToSave: BoInstanceAmountToSave): Observable<void>;

  openBoInstanceDialog(boiDialogData: BoiDialogData): Observable<BoInstanceToSave>;

  validateForUnique(businessObjectId: string, fieldId: string, value: string): Promise<boolean>;

  loadNewId(): Promise<string>;

  createDraft(): Observable<string>;

  applyAndRemoveDraft(draftId: string): Observable<void>;

  removeDraft(draftId): Observable<void>;

  loadAllBoInstanceIds(businessObjectId: string): Observable<string[]>;

  showAccessDeniedNotification(message: string): void;
}
